var _rect, _rect2, _path, _path2, _path3, _path4, _mask, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLexiTroveLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 146,
    viewBox: "0 0 92 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 142.878,
    width: 24.0253,
    height: 2.12248,
    fill: "white",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 66.767,
    y: 142.878,
    width: 24.0253,
    height: 2.12248,
    fill: "white",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.9917 142.538H68.1327V42.6534H89.7838L88.9917 142.538Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8687 142.538H88.9917M88.9917 142.538L89.7838 42.6534H68.1327V142.538H88.9917Z",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6422 142.573H2.06238V42.6534H23.4237L22.6422 142.573Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.80188 142.573H22.6422M22.6422 142.573L23.4237 42.6534H2.06238V142.573H22.6422Z",
    stroke: "black"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-1_136_27",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.7996 42.2526C89.7996 31.1791 85.164 20.5592 76.9126 12.729C68.6612 4.89892 57.4699 0.500001 45.8007 0.5C34.1315 0.499999 22.9402 4.89892 14.6888 12.729C6.43746 20.5592 1.80188 31.1791 1.80188 42.2526L23.5121 42.2526C23.5121 36.643 25.8603 31.2633 30.0403 27.2967C34.2202 23.3302 39.8894 21.1018 45.8007 21.1018C51.712 21.1018 57.3812 23.3302 61.5612 27.2967C65.7411 31.2633 68.0894 36.643 68.0894 42.2526H89.7996Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7996 42.2526C89.7996 31.1791 85.164 20.5592 76.9126 12.729C68.6612 4.89892 57.4699 0.500001 45.8007 0.5C34.1315 0.499999 22.9402 4.89892 14.6888 12.729C6.43746 20.5592 1.80188 31.1791 1.80188 42.2526L23.5121 42.2526C23.5121 36.643 25.8603 31.2633 30.0403 27.2967C34.2202 23.3302 39.8894 21.1018 45.8007 21.1018C51.712 21.1018 57.3812 23.3302 61.5612 27.2967C65.7411 31.2633 68.0894 36.643 68.0894 42.2526H89.7996Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    mask: "url(#path-7-inside-1_136_27)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9736 25.4798H38.9194L34.2346 0.5H57.6583L52.9736 25.4798Z",
    fill: "black",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLexiTroveLogo);
export default __webpack_public_path__ + "static/media/LexiTrove Logo.db65d1950f1d631fce7a19e920209e95.svg";
export { ForwardRef as ReactComponent };